import { defineCopy } from "@tami/core/intl";

import { SHEET_COPY_EN_US } from "./en-us/sheet.copy";
import { SHEET_COPY_ES_ES } from "./es-es/sheet.copy";

/** Textos da folha lateral/inferior (Radix). */
export const SHEET_COPY_PT_BR = {
  close: "Fechar",
} as const;

export const SHEET_COPY = defineCopy(SHEET_COPY_PT_BR, {
  "en-US": SHEET_COPY_EN_US,
  "es-ES": SHEET_COPY_ES_ES,
});
